export function estimatedDelivery() {
  let block = document.getElementById('estimated-delivery-block');
  if (!block) return;

  let daysAhead = parseInt(block.getAttribute('data-days-ahead'), 10) || 0;
  let todayStr = block.getAttribute('data-today');
  if (!todayStr) return;

  let today = new Date(todayStr);
  if (isNaN(today.getTime())) return;
  
  function addWeekdays(date, days) {
    let result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    if (result.getDay() === 6) {
      result.setDate(result.getDate() + 2);
    } else if (result.getDay() === 0) {
      result.setDate(result.getDate() + 1);
    }
    return result;
  }

  let deliveryDate = addWeekdays(today, daysAhead);
  let options = { month: 'long', day: 'numeric' };
  let formatted = deliveryDate.toLocaleDateString(undefined, options);
  document.querySelectorAll('.estimated-delivery-date').forEach(el => {
    el.innerHTML = formatted;
  });
}

estimatedDelivery();
